import { Color, Flex, Icon, Spacing, Text } from '@billy/design-system'
import { ReactElement, ReactNode } from 'react'

import * as Styled from '../../styles'

interface ImportedInvoiceDocumentPreviewMessageProps {
  children?: ReactNode
  message: string
}

export const ImportedInvoiceDocumentPreviewMessage = ({
  children,
  message,
}: ImportedInvoiceDocumentPreviewMessageProps): ReactElement => (
  <Styled.ImportedInvoiceDocumentPreviewWrapper>
    <Flex
      alignItems="center"
      flexDirection="column"
      flexGrow={1}
      gap={Spacing.S12}
      justifyContent="center"
      width="100%"
    >
      <Icon aria-hidden color={Color.Grey400} icon="fileXCorner" size="lg" />
      <Text alignment="center" colorVariant="secondary" role="alert" variant="bodySM">
        {message}
      </Text>
      {children}
    </Flex>
  </Styled.ImportedInvoiceDocumentPreviewWrapper>
)
